import React, {useCallback, useEffect} from "react";
import { withStyles } from "@material-ui/styles";
import ViewPageLayout from "../../../../../../ui/ViewPageLayout";
import StatisticQuestionItem from "./StatisticQuestionItem";
import {getQuestions} from "../../../../store/actions";
import {connect} from "react-redux";

const styles = () => ({

});

export const Statistic = ({ questions, getQuestions, quizId, classes }) => {

  useEffect(() => {
    getQuestions(quizId);
  }, [quizId]);

  //const [data, setData] = React.useState(initialData || defaultData);

  /*const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };*/

  return <ViewPageLayout header="Статистика ответов">
    {questions && questions.map((item, idx) => (
      <StatisticQuestionItem key={`question-stat-item-${idx}`}
                             question={item}/>
    ))}
  </ViewPageLayout>
};

const mapStateToProps = state => ({
  questions: state.manageQuiz.questions
});

const mapDispatchToProps = dispatch => ({
  getQuestions: id => dispatch(getQuestions(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Statistic));
